import { ApolloClient, gql } from 'apollo-boost';

const indicatorDetailsQuery = gql`
  query allNpoReportIndicators($reportId: Int!) {
    allNpoReportIndicators(filters: { reportId: $reportId, enabled: true }) {
      edges {
        node {
          stageId
          indicatorId
          indicatorName
          indicatorDefinition
          forecast
          interventionDosageLevel
          interventionDosageType
          interventionDosageNumber
          finalForecast
          happensAfterProgramYear
          timePeriod
          measurement
          file
        }
      }
    }
  }
`;

const allResultsQuery = gql`
  query allResults($reportId: Int!) {
    allResults(filters: { reportId: $reportId }) {
      edges {
        node {
          dbId
          description
          timeHorizon
          forecastCurrent
          forecastInitial
          forecastVariance
          indicatorId
          successCriteria
          classification
          measurementType
          currentForecastFullClaim
          currentForecastFundedClaim
          enabled
          file
          npoIndicatorFile
          relevant
          level1Forecast
          level1Guess
          level1IsHuman
          level1ForecastResultOne
          indicator {
            id
            dbId
            name
            stageId
            customizable
            unit
            definitionStart
            definitionEnd
            initialForecastStart
            initialForecastEnd
            initialMeasurementStart
            initialMeasurementEnd
            outcome
            impactReceiptText
            forecastOutcome
            finalOutcome
            finalForecastStart
            finalForecastEnd
            isHuman
            finalMeasurementStart
            finalMeasurementEnd
            definition
            stgName
            version
          }
        }
      }
    }
  }
`;

export const getReportIndicatorDetails = (
  client: ApolloClient<object>,
  reportId: number | string,
) => {
  return client.query({
    query: indicatorDetailsQuery,
    variables: {
      reportId,
    },
    fetchPolicy: 'network-only',
  });
};

export const getReportIndicators = (
  client: ApolloClient<object>,
  reportId: number | string,
) => {
  return client.query({
    query: allResultsQuery,
    variables: {
      reportId,
    },
    fetchPolicy: 'network-only',
  });
};

const deleteReportIndicatorMutation = gql`
  mutation DeleteReportIndicator($reportId: Int!, $indicatorId: Int!) {
    deleteReportIndicatorByIds(reportId: $reportId, indicatorId: $indicatorId) {
      success
    }
  }
`;

export const deleteReportIndicator = (
  client: ApolloClient<object>,
  reportId: number | string,
  indicatorId: number,
) => {
  return client.mutate<{ deleteReportIndicatorByIds: { success: boolean } }>({
    mutation: deleteReportIndicatorMutation,
    variables: {
      reportId: Number(reportId),
      indicatorId,
    },
  });
};
